import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import billIcon from '../assets/icons/bill.svg';

const AddressBlock = (props) => {
	const { selectedAdrs, handleStep, handleAdrsClick, type } = props;
	return (
		<div
			className={classNames(
				'newAdrsBlock px-3 py-2 d-flex flex-column',
				(type === 'display' || type === 'store') && 'mt-2 mt-md-3'
			)}
			style={{ maxWidth: type === 'display' || type === 'store' ? 380 : 400 }}
		>
			<div className="d-flex flex-row align-items-start justify-content-between">
				<div>
					<p className="m-0 subDesc">
						<span
							style={{
								fontWeight: '600',
								color: 'black',
								textDecoration: 'none'
							}}
						>
							{selectedAdrs.name}
						</span>: {selectedAdrs.address1 && selectedAdrs.address1 + ', '}
						{selectedAdrs.address2 && selectedAdrs.address2 + ', '}
						{selectedAdrs.landmark && selectedAdrs.landmark + ', '}
						{selectedAdrs.city && selectedAdrs.city.name + ', '}
						{selectedAdrs.pincode && selectedAdrs.pincode}
					</p>
					{selectedAdrs.phonenumber && <p className="m-0 subDesc">{selectedAdrs.phonenumber}</p>}
				</div>
				{type === 'edit' && (
					<div className="pointer pl-3 editIcon" onClick={() => handleAdrsClick(selectedAdrs.id)}>
						<i className="fa fa-pencil" />
					</div>
				)}
			</div>

			{(type === 'edit' || type === 'store') && (
				<button className="mt-2 smallBtn" style={{ background: '#55B126' }} onClick={() => handleStep(3)}>
					{type === 'edit' ? 'Deliver Here' : 'Next'}
				</button>
			)}
		</div>
	);
};

const storeAddress = {
	name: 'Meoan Organics',
	address1: 'Plot 37/c',
	address2: 'Lanco Hills Road',
	landmark: 'Opp Lanco Hanging Gardens',
	pincode: '500032',
	area_name: 'Madhapur',
	city: {
		name: 'Hyderabad'
	},
	state: {
		name: 'Telangana'
	}
};

class CheckoutPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showOtpSection: false,
			activeStep: 1,
			selectedDate: null,
			showMobileBill: false,
			phnNumber: '',
			selectedType: 'delivery',
			selectedAdrs: null,
			openTimeSlots: false,
			timeSlots: [ '5.00am - 9:00am', '10.00pm - 5:00pm', '5.00pm - 9:00am' ],
			selectedTimeSlot: '5.00am - 9:00am'
		};

		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;

		document.getElementById('body').style.paddingTop = '0px';
	}
	componentDidMount() {
		let selectedAdrs = localStorage.getItem('selectedAdrs');
		if (selectedAdrs) {
			selectedAdrs = JSON.parse(selectedAdrs);
			this.setState({ selectedAdrs });
		}
	}
	sendOtp = () => {
		if (this.state.phnNumber.length === 10) this.setState({ showOtpSection: true });
	};
	handleStep = (step) => {
		this.setState({ activeStep: step });
	};
	selectDate = (date) => {
		this.setState({ selectedDate: date });
	};
	handleAdrsClick = (id) => {
		this.props.history.push('/addresses/' + id);
	};
	selectTimeSlot = (slot) => {
		this.setState({ selectedTimeSlot: slot, openTimeSlots: false });
	};

	render() {
		const {
			showOtpSection,
			activeStep,
			selectedDate,
			showMobileBill,
			selectedType,
			selectedAdrs,
			phnNumber,
			openTimeSlots,
			timeSlots,
			selectedTimeSlot
		} = this.state;

		return (
			<div className="checkout-page">
				<div className="plainHeader">
					<Link className="logo" to="/">
						<img src={require('assets/imgs/logo.png')} alt="" className="" />
					</Link>
				</div>
				<div className="my-0 my-md-5 container checkout px-0 px-md-1 px-lg-3">
					<div className="row m-0">
						{/* For mobile */}
						<div className="col-12 d-block d-md-none mb-0 px-0 mobileBill">
							<div
								className="d-flex flex-row align-items-center justify-content-between mobileBillHead"
								onClick={() =>
									this.setState((prevState) => ({
										showMobileBill: !prevState.showMobileBill
									}))}
							>
								<div className="d-flex flex-row align-items-center">
									<img src={billIcon} alt="" />
									<p className="m-0 ml-2 ml-sm-3 mr-1 mr-sm-2">
										{!showMobileBill ? 'Show' : 'Hide'} order summary
									</p>
									{!showMobileBill ? (
										<i className="fa fa-chevron-down" />
									) : (
										<i className="fa fa-chevron-up" />
									)}
								</div>
								<h5 className="m-0">₹306.00</h5>
							</div>
							{showMobileBill && (
								<div className="mobileBillContent">
									<div className="bill">
										<b>
											<h5>Bill Details</h5>
										</b>
										<div className="d-flex align-items-center justify-content-between mt-2 mt-sm-3">
											<p className="m-0">Total</p>
											<h6 className="m-0">₹180</h6>
										</div>
										<div className="d-flex align-items-center justify-content-between mt-1 mt-sm-2 delivery">
											<p className="m-0">Delivery Charges</p>
											<h6 className="m-0">+ ₹20</h6>
										</div>
										<div className="d-flex align-items-center justify-content-between mt-2 mt-sm-3 total pb-3">
											<h6 className="m-0 subtitle">Total Payable</h6>
											<h6 className="m-0 price pt-2">₹200</h6>
										</div>
									</div>
									<div className="mt-4 mt-md-5 coupons">
										<h5 className="m-0">Coupons</h5>
										<div className="mt-3">
											<div className="input-group">
												<input
													type="text"
													className="form-control"
													id="inlineFormInputGroup"
													placeholder="Enter Coupon Code"
												/>
												<div className="input-group-prepend">
													<div className="input-group-text">Apply</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}
						</div>
						{/* For desktop */}
						<div className="col-md-5 d-none d-md-block">
							<div className="px-2 px-md-3 px-lg-5">
								<div className="bill">
									<b>
										<h5>Bill Details</h5>
									</b>
									<div className="d-flex align-items-center justify-content-between mt-3">
										<p className="m-0">Total</p>
										<h6 className="m-0">₹180</h6>
									</div>
									<div className="d-flex align-items-center justify-content-between mt-2 delivery">
										<p className="m-0">Delivery Charges</p>
										<h6 className="m-0">+ ₹20</h6>
									</div>
									<div className="d-flex align-items-center justify-content-between mt-3 total pb-3">
										<h6 className="m-0 subtitle">Total Payable</h6>
										<h6 className="m-0 price pt-2">₹200</h6>
									</div>
								</div>
								<div className="mt-5 coupons">
									<h5 className="m-0">Coupons</h5>
									<div className="mt-3">
										<div className="input-group">
											<input
												type="text"
												className="form-control"
												id="inlineFormInputGroup"
												placeholder="Enter Coupon Code"
											/>
											<div className="input-group-prepend">
												<div className="input-group-text">Apply</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="col-md-7 px-0 px-md-3">
							<div className="px-0 px-md-1 px-lg-5">
								<div
									className={classNames(
										'section',
										activeStep === 1 && 'active',
										activeStep > 1 && 'done'
									)}
								>
									<div className="step">
										<span>1</span>
										<i className="fa fa-check" />
									</div>
									<div>
										<div>
											<h6 className="m-0">Phone Number Verification</h6>
											{activeStep > 1 && <p className="m-0 mt-1 subDesc">91-{phnNumber}</p>}
										</div>
										<div className="details">
											{!showOtpSection ? (
												<div id="phn-nmbr-section">
													<p className="m-0 desc mt-1">
														We need your phone number so that we can update you about your
														order.
													</p>
													<div className="mt-2 phone d-flex align-items-center">
														<input
															className="form-control"
															type="tel"
															placeholder="Phone number"
															maxLength="10"
															minLength="10"
															value={phnNumber}
															onChange={(e) =>
																this.setState({ phnNumber: e.target.value })}
														/>
														<button
															className="mt-2 mt-sm-0 ml-0 ml-sm-2 ml-lg-3"
															onClick={this.sendOtp}
															disabled={phnNumber.length < 10}
														>
															Next
														</button>
													</div>
												</div>
											) : (
												<div>
													<p className="m-0 desc mt-1">
														Enter 4 digit code send to your mobile number
													</p>
													<div className="mt-2 d-flex align-items-center otp-section">
														<div className="d-flex">
															<input className="form-control" />
															<input className="form-control" />
															<input className="form-control" />
															<input className="form-control" />
														</div>
														<button
															className="mt-2 mt-sm-0 mx-0 mx-sm-2"
															onClick={() => this.handleStep(2)}
														>
															Next
														</button>
													</div>
												</div>
											)}
										</div>
									</div>
								</div>
								<div
									className={classNames(
										'section',
										activeStep === 2 && 'active',
										activeStep > 2 && 'done'
									)}
								>
									<div className="step">
										<span>2</span>
										<i className="fa fa-check" />
									</div>
									<div className="w-100">
										<div>
											<div className="d-flex flex-row align-items-center justify-content-between">
												<h6 className="m-0">
													{selectedType === 'delivery' ? activeStep > 2 ? (
														'Ship To'
													) : (
														'Delivery Address'
													) : (
														'Store Pickup'
													)}
												</h6>
												{activeStep > 2 && (
													<p
														className="m-0 mr-1 mr-sm-2 mr-md-3 pointer subDesc"
														onClick={() => this.setState({ activeStep: 2 })}
														style={{ color: '#4E88F5', fontWeight: '600' }}
													>
														Change
													</p>
												)}
											</div>
											{activeStep > 2 && (
												<AddressBlock
													selectedAdrs={
														selectedType === 'delivery' ? selectedAdrs : storeAddress
													}
													handleStep={this.handleStep}
													handleAdrsClick={this.handleAdrsClick}
													type="display"
												/>
											)}
										</div>
										<div className="details addrs mt-3 mr-0 mr-mb-3 mb-1">
											<div className="types mt-1 d-flex flex-row">
												<div
													className={classNames(
														'd-flex flex-row type mr-4 pointer',
														selectedType === 'delivery' && 'selected'
													)}
													onClick={() => this.setState({ selectedType: 'delivery' })}
												>
													<div className="circle">
														<div className="innerCircle" />
													</div>
													<p className="m-0">Delivery</p>
												</div>
												<div
													className={classNames(
														'd-flex flex-row type mr-4 pointer',
														selectedType === 'pickup' && 'selected'
													)}
													onClick={() => this.setState({ selectedType: 'pickup' })}
												>
													<div className="circle">
														<div className="innerCircle" />
													</div>
													<p className="m-0">Pickup</p>
												</div>
											</div>
											<div className="mt-3">
												{selectedType === 'delivery' ? (
													<div>
														{selectedAdrs ? (
															<AddressBlock
																selectedAdrs={selectedAdrs}
																handleStep={this.handleStep}
																handleAdrsClick={this.handleAdrsClick}
																type="edit"
															/>
														) : (
															<div className="newAdrsBlock mr-2 mr-md-3 mr-lg-4">
																<div
																	className="block text-center mx-4 mx-md-5 my-3 my-md-4 pointer"
																	onClick={() => this.handleAdrsClick('new')}
																>
																	Add Delivery Address
																</div>
															</div>
														)}
													</div>
												) : (
													<AddressBlock
														selectedAdrs={storeAddress}
														handleStep={this.handleStep}
														handleAdrsClick={this.handleAdrsClick}
														type="store"
													/>
												)}
											</div>
										</div>
									</div>
								</div>
								<div
									className={classNames(
										'section',
										activeStep === 3 && 'active',
										activeStep > 3 && 'done'
									)}
								>
									<div className="step">
										<span>3</span>
										<i className="fa fa-check" />
									</div>
									<div className="date-nd-time">
										<h6 className="m-0">Delivery Date & Time</h6>
										<div className="details mt-3 mb-1">
											<div className="date-section m-0 p-0">
												<div
													className={classNames(
														'date',
														selectedDate === 'date1' && 'active-date'
													)}
													id="date1"
													onClick={() => this.selectDate('date1')}
												>
													<div className="d-flex flex-column">
														<p className="m-0">TUE</p>
														<span>23 JUNE</span>
													</div>
												</div>
												<div
													className={classNames(
														'date',
														selectedDate === 'date2' && 'active-date'
													)}
													id="date2"
													onClick={() => this.selectDate('date2')}
												>
													<div className="d-flex flex-column">
														<p className="m-0">WED</p>
														<span>24 JUNE</span>
													</div>
												</div>
												<div
													className={classNames(
														'date',
														selectedDate === 'date3' && 'active-date'
													)}
													id="date3"
													onClick={() => this.selectDate('date3')}
												>
													<div className="d-flex flex-column">
														<p className="m-0">THU</p>
														<span>25 JUNE</span>
													</div>
												</div>
												<div
													className={classNames(
														'date',
														selectedDate === 'date4' && 'active-date'
													)}
													id="date4"
													onClick={() => this.selectDate('date4')}
												>
													<div className="d-flex flex-column">
														<p className="m-0">FRI</p>
														<span>26 JUNE</span>
													</div>
												</div>
												<div
													className={classNames(
														'date',
														selectedDate === 'date5' && 'active-date'
													)}
													id="date5"
													onClick={() => this.selectDate('date5')}
												>
													<div className="d-flex flex-column">
														<p className="m-0">SAT</p>
														<span>27 JUNE</span>
													</div>
												</div>
												<div
													className={classNames(
														'date',
														selectedDate === 'date6' && 'active-date'
													)}
													id="date6"
													onClick={() => this.selectDate('date6')}
												>
													<div className="d-flex flex-column">
														<p className="m-0">SUN</p>
														<span>28 JUNE</span>
													</div>
												</div>
											</div>
											<div className="time-section mt-3 mt-md-4">
												<div className="d-flex flex-row align-items-center">
													<p className="subDesc m-0" style={{ color: '#57679C' }}>
														Slot Time
													</p>
													<div className="timeBlock ml-3">
														<div
															className="d-flex flex-row align-items-center justify-content-between pointer"
															onClick={() =>
																this.setState((prevState) => ({
																	openTimeSlots: !prevState.openTimeSlots
																}))}
														>
															<p className="m-0 mr-2">{selectedTimeSlot}</p>
															<i className="fa fa-chevron-down" />
														</div>
														{openTimeSlots && (
															<div className="timeSlots">
																{timeSlots.map((slot, index) => (
																	<div
																		className={classNames(
																			'slot',
																			selectedTimeSlot === slot && 'selected'
																		)}
																		key={index}
																		onClick={() => this.selectTimeSlot(slot)}
																	>
																		<p>{slot}</p>
																	</div>
																))}
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="mx-2 mx-sm-0">
									<button
										className={classNames(
											'proceed pb-3',
											(activeStep !== 3 || selectedDate === null) && 'disabled'
										)}
										disabled={activeStep !== 3 || selectedDate === null}
										onClick={() => alert('Proceed to payment')}
									>
										Proceed to Payment
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default CheckoutPage;
